import React from 'react';
import SettingsContainer, { SettingsSettingType } from '../../../components/settings/SettingsContainer';

const ProposalSettings: React.FC = () => {
    const settings: SettingsSettingType[] = [
        {
            title: 'proposal.settings.numbering_scheme_title',
            explanationText: 'proposal.settings.numbering_scheme_explanation',
            fields: [
                {
                    type: 'text',
                    label: 'settings.general.number_sequence_title',
                    name: 'proposal_numbering_scheme',
                    placeholder: '',
                    group: 'field-row',
                    width: '30%',
                    shouldAutoFocus: false
                },
                {
                    type: 'number',
                    label: 'settings.general.next_number_label',
                    name: 'proposal_current_number',
                    group: 'field-row',
                    width: '30%'
                }
            ]
        },
    ];

    return (
        <SettingsContainer settings={settings} environmentScope={true} />
    );
};

export default ProposalSettings;